import { useCallback, useMemo, useState } from 'react';
import { RefreshControl } from 'react-native';

export const useRefreshControl = (onRefresh?: () => Promise<unknown>) => {
	const [refreshing, setRefreshing] = useState(false);

	const handleOnRefresh = useCallback(async () => {
		if (!onRefresh) {
			return;
		}

		setRefreshing(true);
		try {
			await onRefresh();
		} finally {
			setRefreshing(false);
		}
	}, [onRefresh]);

	const refreshControl = useMemo(
		() => onRefresh && <RefreshControl refreshing={refreshing} onRefresh={handleOnRefresh} />,
		[onRefresh, handleOnRefresh, refreshing],
	);

	return { refreshControl };
};
